export enum ProgressErrors {
  NO_CURRENT_PROFILE = 'no_current_profile',
}

export enum SoundsWritingErrors {
  INVALID_STATE = 'invalid_state',
  INVALID_GRADER = 'invalid_grader',
  INVALID_STEP = 'invalid_step',
  INVALID_STEP_TYPE = 'invalid_step_type',
  INVALID_WRITING_PATH = 'invalid_writing_path',
}

export enum AppStateErrors {
  NO_HANDLER_FOUND = 'no_handler_found',
  INVALID_STATE = 'invalid_state',
}

export enum CapitalLettersErrors {
  INVALID_STATE = 'invalid_state',
  INVALID_GRADER = 'invalid_grader',
  INVALID_STEP = 'invalid_step',
  INVALID_STEP_TYPE = 'invalid_step_type',
  INVALID_TASK_TYPE = 'invalid_task_type',
  INVALID_STEP_TARGET = 'invalid_step_target',
}

export enum WordFindingErrors {
  INVALID_STEP_TARGET = 'invalid_step_target',
}
